import { useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Upload, Download, RefreshCw, Loader2 } from "lucide-react";
import { postUpload } from "@/components/ConflittoNome";

const btn = "inline-flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-semibold border transition-colors disabled:opacity-40";

export function ChecklistDocAzioni({ entityType, entityId, tipo, label, files, canUpload, onDone }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const mine = files.filter((f) => f.doc_tipo === tipo);
  const ultimo = mine[0];
  const carica = async (f) => {
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f); fd.append("entity_type", entityType); fd.append("entity_id", entityId); fd.append("kind", "documento"); fd.append("doc_tipo", tipo);
      const nuovo = await postUpload(fd);
      if (fd.get("conflitto") !== "entrambi") for (const old of mine) if (old.id !== nuovo?.id) await api.delete(`/files/${old.id}`).catch(() => {});
      toast.success(`${label}: ${mine.length ? "sostituito" : "caricato"}`);
      onDone();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  const scarica = async () => {
    try {
      const r = await api.get(`/files/${ultimo.id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = url; a.download = ultimo.original_filename || label; a.click(); URL.revokeObjectURL(url);
    } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="shrink-0 flex items-center gap-1.5" data-testid={`doc-azioni-${tipo}`}>
      {ultimo && <button data-testid={`doc-scarica-${tipo}`} onClick={scarica} title={ultimo.original_filename} className={`${btn} border-[var(--border)] bg-white text-slate-700 hover:bg-slate-50`}><Download size={13} /> Scarica</button>}
      {canUpload && (
        <button data-testid={`doc-carica-${tipo}`} onClick={() => ref.current?.click()} disabled={busy}
          className={`${btn} ${ultimo ? "border-[var(--border)] bg-white text-slate-700 hover:bg-slate-50" : "border-transparent bg-[#FC82ED] text-black"}`}>
          {busy ? <Loader2 size={13} className="animate-spin" /> : ultimo ? <RefreshCw size={13} /> : <Upload size={13} />} {ultimo ? "Sostituisci" : "Carica documento"}
        </button>
      )}
      <input ref={ref} type="file" hidden data-testid={`doc-carica-input-${tipo}`} onChange={(e) => carica(e.target.files?.[0])} />
    </div>
  );
}
